
import { contentBlock } from '@/utils/graphql/contentblock'
export function getContentBlock (client: any, alias: String) {
  return new Promise ((resolve) => {
      client.query({
        query: contentBlock,
        variables: {
          alias: alias
        },
      }).then((data: any) => {
        if(data.data.contentBlock) {
          resolve(data.data.contentBlock[0])
        }
      });
    }
  )
}

import { clientList } from '@/utils/graphql/client'
export function getClientLogos (client: any) {
  return new Promise ((resolve) => {
      client.query({
        query: clientList
      }).then((data: any) => {
        if(data.data.client) {
          resolve(data.data.client.filter((data: any) => { return data.showOnHomepage }))
        }
      });
    }
  )
}

import { clientQuotes } from '@/utils/graphql/contentblock'
export function getClientQuotes (client: any) {
  return new Promise ((resolve) => {
        client.query({
          query: clientQuotes
        }).then((data: any) => {
            if(data.data.contentBlock) {
              resolve(data.data.contentBlock[0])
            }
        });
    }
  )
}

export function getClientSlug (alias: String) {
    if(alias == '') { return alias }
    return alias.replace('client-', '')
}

export function getSubsidiarySlug (alias: String) {
    if(alias == '') { return alias }
    return alias.replace('subsidiary-', '')
}

import { caseStudyThumbnail } from '@/utils/graphql/client'
export function getCaseStudyThumbnail (client: any) {
  return new Promise ((resolve) => {
      client.query({
        query: caseStudyThumbnail
      }).then((data: any) => {
        if(data.data.client) {
            resolve(data.data.client.filter((data: any) => {
              const flow = data.flow;
              return flow != null && flow.contentItems.length > 0;
            }))
        }
      });
    }
  )
}

import { caseStudyList } from '@/utils/graphql/client'
export function getCaseStudyList (client: any) {
  return new Promise ((resolve) => {
      client.query({
        query: caseStudyList
      }).then((data: any) => {
        if(data.data.client) {
            resolve(data.data.client.filter((data: any) => {
              const flow = data.flow;
              return flow != null && flow.contentItems.length > 0;
            }))
        }
      });
    }
  )
}

import { caseStudy } from '@/utils/graphql/client'
export function getCaseStudy (client: any, alias: String) {
  return new Promise ((resolve) => {
      client.query({
        query: caseStudy,
        variables: {
          alias: alias
        },
      }).then((data: any) => {
        if(data.data.client) {
          resolve(data.data.client[0])
        }
      });
    }
  )
}

import { subsidiaries } from '@/utils/graphql/subsidiaries'
export function getSubsidiaries (client: any) {
  return new Promise ((resolve) => {
      client.query({
        query: subsidiaries
      }).then((data: any) => {
        if(data.data.subsidiaries) {
          resolve(data.data.subsidiaries)
        }
      });
    }
  )
}

import { subsidiaryDetails } from '@/utils/graphql/subsidiaries'
export function getSubsidiaryDetails (client: any, alias: String) {
  return new Promise ((resolve) => {
      client.query({
        query: subsidiaryDetails,
        variables: {
          alias: alias
        },
      }).then((data: any) => {
        if(data.data.subsidiaries) {
          resolve(data.data.subsidiaries[0])
        }
      });
    }
  )
}